import { Box, Typography } from "@mui/material";
import "./loading.css";
import { greyEnabled } from "../../theme/colors";

interface LoadingProps {
  size?: number;
  label?: string;
  /**
   * Minimum height of the wrapper so the spinner visually centers itself
   * even when an ancestor doesn't have a real, resolvable height (e.g. a
   * `height="100%"` box under an auto-height parent collapses to 0, which
   * pins the spinner to the top instead of centering it). Set to 0 to opt
   * out for tight, non-page contexts.
   */
  minHeight?: number;
}

const BAR_COUNT = 5;

export default function Loading({ size = 28, label, minHeight = 280 }: LoadingProps) {
  const barWidth = Math.max(3, Math.round(size / 8));
  const gap = Math.max(2, Math.round(size / 11));

  return (
    <Box
      role="status"
      aria-label={label || "Loading"}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={0.75}
      width="100%"
      minHeight={minHeight}
    >
      <Box className="ami-bars" sx={{ height: size, gap: `${gap}px` }}>
        {Array.from({ length: BAR_COUNT }).map((_, i) => (
          <Box
            key={i}
            className="ami-bar"
            sx={{ width: barWidth, height: "100%" }}
          />
        ))}
      </Box>
      {label && (
        <Typography variant="body2" color={greyEnabled}>
          {label}
        </Typography>
      )}
    </Box>
  );
}
